<template lang="pug">
.uc-max-h-available(ref="elRef")
  slot
</template>

<script setup lang="ts">
import { useEventListener } from '@vueuse/core';
import { onMounted, onUnmounted, ref } from 'vue';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const elRef = ref<HTMLElement>();

const updateSize = () => {
  const el = elRef.value;
  if (!el) return;

  const scroller = el.closest<HTMLElement>('.scroller, .overflow-y-auto');

  // grow the element to test the scroller's max height
  el.style.maxHeight = 'none';
  el.style.height = '200vh';

  // get the height of the scroller
  const scrollerHeight = scroller?.clientHeight || 0;
  el.style.height = '';
  el.style.maxHeight = `${scrollerHeight * 0.875}px`;
};

onMounted(updateSize);
useEventListener(window, 'resize', updateSize);
onMounted(() => ScrollTrigger.addEventListener('refresh', updateSize));
onUnmounted(() => ScrollTrigger.removeEventListener('refresh', updateSize));
</script>
